<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen py-10 px-4">
    <AppHeader />

    <div class="max-w-5xl mx-auto space-y-6">
      <h1 class="text-3xl font-bold">Meus Favoritos</h1>

      <div
        v-if="favorites.length === 0"
        class="bg-white p-6 rounded-2xl shadow text-gray-500 text-center"
      >
        Nenhum projeto favoritado ainda.
      </div>

      <!-- LISTA DE FAVORITOS -->
      <div
  v-for="project in favorites"
  :key="project.id"
  class="bg-white shadow rounded-2xl p-6 flex justify-between items-center"
>
  <!-- TÍTULO -->
  <router-link
    :to="{
      name: 'detalhes',
      params: { hash: project.hash, slug: project.slug }
    }"
    class="text-xl font-semibold text-[#1f2937] hover:underline"
  >
    {{ project.title }}
  </router-link>

  <div class="flex gap-3 items-center">
    <!-- DESFAVORITAR -->
    <button
      @click="unfavorite(project.id)"
      class="text-red-500 hover:text-red-600 text-sm font-semibold"
    >
      Remover
    </button>

    <!-- VER PROJETO -->
    <router-link
      :to="{
        name: 'detalhes',
        params: { hash: project.hash, slug: project.slug }
      }"
      class="bg-[#b99a52] text-white px-4 py-2 rounded-xl font-semibold"
    >
      Ver Projeto
    </router-link>
  </div>
</div>

    </div>

    <AppFooter />
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import api from '@/services/api'
import { useLoadingStore } from '@/store/loadingStore'

const { proxy } = getCurrentInstance()
const loadingStore = useLoadingStore()

const favorites = ref([])
const userData = JSON.parse(localStorage.getItem('userData') || '{}')

onMounted(loadFavorites)

async function loadFavorites() {
  try {
    loadingStore.show()
    const res = await api.get(`/favorites`)
    favorites.value = res.data.data || []
  } catch (error) {
    proxy.$swal.fire({
      icon: 'error',
      text: 'Erro ao carregar favoritos'
    })
  } finally {
    loadingStore.hide()
  }
}

async function unfavorite(projectId) {
  // snapshot localStorage
  const stored = JSON.parse(localStorage.getItem('wm_favorites') || '[]')
  const previous = [...stored]

  // remove do localStorage
  const updated = stored.filter(id => id !== projectId)
  localStorage.setItem('wm_favorites', JSON.stringify(updated))

  try {
    // api toggle
    await api.post('/favorites/toggle', { project_id: projectId })

    // recarrega lista
    await loadFavorites()

  } catch (error) {
    // rollback
    localStorage.setItem('wm_favorites', JSON.stringify(previous))

    proxy.$swal.fire({
      icon: 'error',
      text: 'Erro ao remover favorito'
    })
  }
}

</script>
